import { Dispatch, SetStateAction, useState } from "react";
import { UseQueryResult, useQuery } from "react-query";
import { getConsentService } from "../services/getConsentsService";
import {
  ConsentResponse,
  ProfileUsers,
  ResponseGetConsentProfileService,
  UserType,
  useQueryApiError
} from "../types";

type FormType = {
  email: string;
  serviceProvider: string;
  nroDocumento?: string;
  tipoDocumento?: string;
  currentUser: UserType;
  isB2B?: boolean;
  isEnterprise?: boolean;
};

export const initialForm: FormType = {
  email: "",
  tipoDocumento: "",
  nroDocumento: "",
  serviceProvider: "",
  currentUser: {
    token: "",
    email: "",
    name: ""
  },
  isB2B: false,
  isEnterprise: false
};

type ConsentHookType = {
  consentQuery: UseQueryResult<ResponseGetConsentProfileService, useQueryApiError>;
  setFetched: Dispatch<SetStateAction<boolean>>;
  getConsents?: ConsentResponse[];
  getProfile?: ProfileUsers;
};

export const useConsent = (form: FormType): ConsentHookType => {
  const [fetched, setFetched] = useState(false);

  const keyCache = `userinfo-${form.email}-${form.serviceProvider}`;

  const consentQuery = useQuery<ResponseGetConsentProfileService, useQueryApiError>(
    [keyCache],
    async () => {
      const response = await getConsentService(form);
      setFetched(false);
      return response;
    },
    { enabled: fetched, cacheTime: 500 }
  );

  return {
    consentQuery,
    setFetched,
    getConsents: consentQuery.data?.consents,
    getProfile: consentQuery.data?.customer
  };
};
